import { breakpoints } from "@brightagency/headstart-common";
import styled, { css } from "styled-components";
import { colors } from "../../../utils/colors";
import { SectionTitle } from "../../atoms/SectionTitle";

export const carouselSectionPadding = css`
    padding: 18px 0 40px;

    ${breakpoints.medium} {
        padding: 48px 0;
    }
`;

export const Wrapper = styled.div`
    background-color: white;
    ${carouselSectionPadding}
`;

export const Inner = styled.div``;

export const Header = styled.div`
    margin-bottom: 24px;

    ${breakpoints.large} {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    }
`;

export const TextContent = styled.div``;

export const Title = styled(SectionTitle)`
    color: ${colors.brandDark};
    margin-bottom: 8px;
`;

export const Content = styled.div`
    margin: 0;
    font-size: 16px;
    color: ${colors.brandDark};

    ${breakpoints.large} {
        font-size: 18px;
    }
`;
